import { api } from "../utils/apiClient";

export const getPersonas = () => api.get("/personas");

export const createReport = (personaIds, name) =>
  api.post("/persona-reports", { name, persona_ids: personaIds });

export const listReports = () => api.get("/persona-reports");

export const getReport = (reportId, config) =>
  api.get(`/persona-reports/${reportId}`, false, config);

export const startDiagnosis = (reportId, personaId) =>
  api.post(`/persona-reports/${reportId}/persona/${personaId}/diagnose`);

export const getDiagnosis = (reportId, personaId) =>
  api.get(`/persona-reports/${reportId}/persona/${personaId}/diagnosis`);

export const updateFixStatus = (reportId, personaId, fixId, status) =>
  api.patch(`/persona-reports/${reportId}/persona/${personaId}/fix/${fixId}`, { status });

export const getPersonaTrends = (config) => api.get("/persona-trends", false, config);
